export var NotificationStatus;
(function (NotificationStatus) {
    NotificationStatus["UNSEEN"] = "UNSEEN";
    NotificationStatus["SEEN_BUT_UNREAD"] = "SEEN_BUT_UNREAD";
    NotificationStatus["READ"] = "READ";
    NotificationStatus["RESOLVED"] = "RESOLVED";
    NotificationStatus["DISMISSED"] = "DISMISSED";
    NotificationStatus["DELETED"] = "DELETED";
})(NotificationStatus || (NotificationStatus = {}));
export var NotificationType;
(function (NotificationType) {
    NotificationType["REGULAR"] = "REGULAR";
    NotificationType["ALERT_WARNING"] = "ALERT_WARNING";
    NotificationType["ALERT_INFO"] = "ALERT_INFO";
})(NotificationType || (NotificationType = {}));
export var IconType;
(function (IconType) {
    IconType["UrlIcon"] = "UrlIcon";
    IconType["AppIcon"] = "AppIcon";
    IconType["PersonAvatar"] = "PersonAvatar";
})(IconType || (IconType = {}));
export var FeedChannel;
(function (FeedChannel) {
    FeedChannel["UNKOWN"] = "UNKOWN";
    FeedChannel["WEB"] = "WEB";
    FeedChannel["MOBILE"] = "MOBILE";
})(FeedChannel || (FeedChannel = {}));
export var SpecialMigrationSpecs;
(function (SpecialMigrationSpecs) {
    SpecialMigrationSpecs["HideChatNotifications"] = "HideChatNotifications";
})(SpecialMigrationSpecs || (SpecialMigrationSpecs = {}));
//# sourceMappingURL=types.impl.js.map